<template>
  <div class="follow-tag__button-wrapper">
    <a-button
      :button-style="buttonStyle"
      class="follow-tag__button"
      @click="onClick"
    >
      <a-icon
        :icon="dynamicIcon"
        :width="16"
        :height="16"
        class="follow-tag__button-icon"
        :class="iconClass"
      />
      <a-visibility hide :on="[$breakpoint.tablet, $breakpoint.mobile]">
        <span class="follow-tag__button-text">
          {{ statusText }}
        </span>
      </a-visibility>
    </a-button>
  </div>
</template>

<script>
import AIcon, { ICON } from 'shared/AIcon/index.vue'
import { BUTTON_STYLE } from 'shared/AButton/index.vue'
import {
  METHOD_NAME,
  PENDING_ACTION,
  PENDING_ACTION_EVENT
} from '~/utils/enums/pending-actions'
import mixins from '~/utils/mixins'
import { propValidator, PROP_TYPES } from '@fmpedia/validators'

export default {
  name: 'AFollowTagButton',
  mixins: [
    mixins.pendingAuthActions,
    mixins.pendingAuthActionsListenersFactory({
      [PENDING_ACTION_EVENT.START_PENDING_ACTION]:
        METHOD_NAME.HANDLE_START_PENDING_ACTION,
      [PENDING_ACTION_EVENT.END_PENDING_ACTION]:
        METHOD_NAME.HANDLE_END_PENDING_ACTION
    })
  ],
  components: { AIcon },
  props: {
    tag: propValidator([PROP_TYPES.OBJECT], false)
  },
  data() {
    return { guid: this.$helper.guid() }
  },
  consts: {
    ICON,
    BUTTON_STYLE
  },
  computed: {
    statusText() {
      return this.tag.isFollowed ? 'Unfollow Tag' : 'Follow Tag'
    },
    buttonStyle() {
      return this.tag.isFollowed ? BUTTON_STYLE.GRAY : BUTTON_STYLE.PURPLE
    },
    dynamicIcon() {
      return this.tag.isFollowed ? ICON.UNFOLLOW_TAG : ICON.FOLLOW_TAG
    },
    iconClass() {
      return {
        unfollow: this.tag.isFollowed
      }
    }
  },
  methods: {
    onClick() {
      const actionData = { id: this.tag.id, newValue: !this.tag.isFollowed }
      this.$_pendingAuthActions_handleAction({
        actionType: PENDING_ACTION.FOLLOW_TAG,
        actionData,
        activatorSelector: `#FollowTag-${this.guid}`
      })
    },
    [METHOD_NAME.HANDLE_START_PENDING_ACTION](refreshPayload) {
      if (refreshPayload.id === this.tag.id) {
        this.inProgress = true
      }
    },
    [METHOD_NAME.HANDLE_END_PENDING_ACTION](refreshPayload) {
      if (refreshPayload.id === this.tag.id) {
        this.inProgress = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.follow-tag__button-wrapper {
  /deep/.a-button__general-style {
    width: fit-content;
    height: fit-content;
    padding: 8px 24px;

    .a-button__slot-wrapper {
      padding: 0;
      display: flex;
      flex-direction: row;
    }
  }
}

.follow-tag__button-icon {
  fill: $c--white;
  margin-right: 6px;

  @include tablet {
    margin-right: 0px;
  }
}

.follow-tag__button-icon.unfollow {
  fill: $c--main;
}

.follow-tag__button-text {
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
}
</style>
